import React from "react";
import { TypeEnum } from "./enums/TypeEnum";
import { IForm } from "./models/Form.model";
import { Utils } from "../../../../utils/Utils";
import FileUpload from "../FileUpload/FileUpload";
import { MultiSelect } from "primereact/multiselect";
import SharedDropdown from "./dropdown/Dropdown";
import SharedInputText from "./inputText/InputText";
import SharedInputTextArea from "./inputTextArea/inputTextArea";
import CodeEditor from "../CodeEditor/CodeEditor";
import SharedInputSwitch from "./InputSwitch/InputSwitch";

export default function SharedForm({
  form,
  setForm,
  setFiles,
}: {
  form: IForm[];
  setForm: any;
  setFiles?: any;
}) {
  const handleFileUpload = (value: File[], index: number) => {
    setFiles(value);
    handleFormData(value, index);
  };

  const handleFormData = (value: any, index: number) => {
    const updatedForm: IForm[] = Utils.deepClone(form);
    updatedForm[index].value = value;
    setForm(updatedForm);
  };

  return (
    <div className="form">
      {form.map((item, i) => {
        let elem;
        switch (item.type) {
          case TypeEnum.Input:
            elem = (
              <>
                <SharedInputText
                  item={item}
                  handleFormData={(v: string) => handleFormData(v, i)}
                />
              </>
            );
            break;
          case TypeEnum.Multiselect:
            elem = (
              <>
                <div className="form-group">
                  <label>{item.label}</label>
                  <MultiSelect
                    value={item.value}
                    onChange={(e) => handleFormData(e.value, i)}
                    options={item.options || []}
                    placeholder={`Select ${item.label}`}
                    maxSelectedLabels={3}
                  />
                </div>
              </>
            );
            break;
          case TypeEnum.Dropdown:
            elem = (
              <>
                <SharedDropdown
                  item={item}
                  handleFormData={(v: any) => handleFormData(v, i)}
                />
              </>
            );
            break;
          case TypeEnum.Description:
            elem = (
              <>
                <SharedInputTextArea
                  item={item}
                  handleFormData={(v: any) => handleFormData(v, i)}
                />
              </>
            );
            break;
          case TypeEnum.FileUpload:
            elem = (
              <>
                <div className="form-group">
                  <label>{item.label}</label>
                  <FileUpload
                    handleChange={(newValue: any) => {
                      handleFileUpload(newValue, i);
                    }}
                  />
                </div>
              </>
            );
            break;
          case TypeEnum.Switch:
            elem = (
              <>
                <SharedInputSwitch
                  item={item}
                  handleFormData={(v: any) => handleFormData(v, i)}
                />
              </>
            );
            break;
          case TypeEnum.Config:
            elem = (
              <div key={i} className="form-group" style={{ flexGrow: 1 }}>
                <label>{item.label}</label>
                <div className="code-editor" style={{ flexGrow: 1 }}>
                  <CodeEditor
                    lang={item.lang || "java"}
                    handleChange={(newValue: string) =>
                      handleFormData(newValue, i)
                    }
                    code={item.value}
                  />
                </div>
              </div>
            );
            break;
        }
        return <React.Fragment key={i}> {elem} </React.Fragment>;
      })}
    </div>
  );
}
